import { render } from "./ViewWrapperSubsection.vue?vue&type=template&id=19bac7c4&scoped=true"
import script from "./ViewWrapperSubsection.vue?vue&type=script&lang=js"
export * from "./ViewWrapperSubsection.vue?vue&type=script&lang=js"

import "./ViewWrapperSubsection.vue?vue&type=style&index=0&id=19bac7c4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bac7c4"]])

export default __exports__